// File: src/hooks/useCreditConsumed.js

import { useState, useEffect } from 'react';
import axios from 'axios';
import { Api_Url } from '../../utils/ApiUrl';

export function useCreditConsumed(startDate, endDate) {
    const [consumedTransactions, setConsumedTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 10;

    useEffect(() => {
        const fetchCreditConsumed = async () => {
            try {
                setLoading(true);
                setError(null);

                const token = localStorage.getItem('accessToken');
                let apiUrl = `${Api_Url}/credit/consumed/transactions?limit=${itemsPerPage}&offset=${page + 1}&orderField=createdAt&orderDirection=-1`;

                if (startDate && endDate) {
                    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
                }

                const response = await axios.get(apiUrl, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                setConsumedTransactions(response.data.data.issuedTransactions);
                setTotalItems(response.data.data.count);
                setPageCount(Math.ceil(response.data.data.count / itemsPerPage));
                setLoading(false);
            } catch (error) {
                console.error('Error fetching credit consumed transactions:', error);
                setError(error.message || 'Failed to fetch credit consumed transactions');
                setLoading(false);
            }
        };

        fetchCreditConsumed();
    }, [startDate, endDate, page]);

    const handlePageChange = (selectedItem) => {
        setPage(selectedItem.selected);
    };

    const startItem = page * itemsPerPage + 1;
    const endItem = Math.min((page + 1) * itemsPerPage, totalItems);

    return {
        consumedTransactions,
        loading,
        error,
        page,
        pageCount,
        totalItems,
        itemsPerPage,
        handlePageChange,
        startItem,
        endItem
    };
}
